import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { AssetAssignment } from '../models/entities/asset-assignment';
import { AssetAssignmentRequest } from '../models/dto/asset-assignment-request';


@Injectable({
  providedIn: 'root'
})
export class AssetAssignmentService {

  constructor(private networkService: LeanNetworkService,  public userService : UserService) { }

  
  //-----------------------------------------------------------------------------------------------------
  assetAssignmentsGet(
    booleans        : boolean[],
    branchCode?      : string,
    partnerCode?     : string, 
    assetProductCode?: string, 
    assetCode?       : string, 
    barCode?         : string, 
    startDate?       : Date, 
    endDate?         : Date)  : Promise<AssetAssignment[]> {
    let request       : BaseRequest = new BaseRequest(this.userService.userInfo);

    request.booleans   = booleans;
    request.strArg1   = branchCode;
    request.strArg2   = partnerCode;
    request.strArg3   = assetProductCode;
    request.strArg4   = assetCode;
    request.strArg5   = barCode;
    
    request.dteArg1   = startDate;
    request.dteArg2   = endDate;
    
    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetAssignmentsGet', request).then(result => {
          return resolve(result.assetAssignments);
        }, error => {
            reject(error);
        });
    });
  }
  //-----------------------------------------------------------------------------------------------------

  assetAssetAssignmentsGet(assetCode : string)  : Promise<AssetAssignment[]> {
    let request    : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.code   = assetCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetAssetAssignmentsGet', request).then(result => {
          return resolve(result.assetAssignments);
        }, error => {
            reject(error);
        });
    });
  }

  //-----------------------------------------------------------------------------------------------------
  assetAssignmentSave(assetAssignment : AssetAssignment) : Promise<AssetAssignment> {
    let request           : AssetAssignmentRequest = new AssetAssignmentRequest(this.userService.userInfo);
    
    request.assetAssignment = assetAssignment;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetAssignmentSave', request).then(result => {
          let assetAssignment : AssetAssignment = result.assetAssignment;
          return resolve(assetAssignment);
        });
    });
  }
  //-----------------------------------------------------------------------------------------------------


  //-----------------------------------------------------------------------------------------------------
  assetAssignmentsAdd(assetProductCode : string, partnerCodes : string[]): Promise<AssetAssignment[]> {
    let request           : BaseRequest = new AssetAssignmentRequest(this.userService.userInfo);
    
    request.code    = assetProductCode;
    request.strings = partnerCodes;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetAssignmentsAdd', request).then(result => {
          return resolve(result.assetAssignments);
        });
    });
  }
  //-----------------------------------------------------------------------------------------------------

  //-----------------------------------------------------------------------------------------------------
  assetAssignmentProcess(assetAssignmentCode : string, service : string, expeditionForecastDate : Date, barCode : string, contractPdf : string, assetProductCode? : string) : Promise<AssetAssignment> {
    let request           : BaseRequest = new BaseRequest(this.userService.userInfo);
    
    request.code    = assetAssignmentCode;
    request.service = service;
    request.dteArg1 = expeditionForecastDate;
    request.strArg1 = barCode;
    request.strArg2 = contractPdf;
    request.strArg3 = assetProductCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetAssignmentProcess', request).then(result => {
          let assetAssignment : AssetAssignment = result.assetAssignment;
          return resolve(assetAssignment);
        });
    });
  }
  //-----------------------------------------------------------------------------------------------------


  //-----------------------------------------------------------------------------------------------------
  assetAssignmentsShipmentSet(assetShipmentCode: string, assetAssignmentCodes : string[]) : Promise<boolean> {
    let request           : BaseRequest = new BaseRequest(this.userService.userInfo);
    
    request.code    = assetShipmentCode;
    request.strings = assetAssignmentCodes;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetAssignmentsShipmentSet', request).then(result => {
          return resolve(true);
        });
    });  
  }
 //-----------------------------------------------------------------------------------------------------

   //-----------------------------------------------------------------------------------------------------
   assetAssignmentShipmentSet(assetShipmentCode: string, assetAssignmentCode : string) : Promise<AssetAssignment> {
    let request           : BaseRequest = new BaseRequest(this.userService.userInfo);
    
    request.code    = assetShipmentCode;
    request.strArg1 = assetAssignmentCode;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetAssignmentShipmentSet', request).then(result => {
          let assetAssignment : AssetAssignment = result.assetAssignment;
          return resolve(assetAssignment);
        });
    });  
  }
 //-----------------------------------------------------------------------------------------------------


 
 
 assetAssignmentContractGet(assetAssignmentCode : string)  : Promise<string> {
  let request    : BaseRequest = new BaseRequest(this.userService.userInfo);
  request.code   = assetAssignmentCode;

  return new Promise((resolve, reject) => {
      this.networkService.post('services/logistics/assetAssignmentContractGet', request).then(result => {
        return resolve(result.strArg1);
      }, error => {
          reject(error);
      });
  });
}

}


